import { ACCOUNT_ACTION_IDS } from '@central-products/interface-account-actions';
import { feature as loginFlowFeature } from '@central-products/login-flow';

const loginButtonConfig = {
  type: '@sitebase/login-button',
  data: {
    id: 'loginButtonId',
  },
  children: [],
};

export const loginPlugin = {
  beforeRender({ header }) {
    header.actions.children.push(loginButtonConfig);
  },
  beforeBootstrap({ addBootstrapperFeature }) {
    addBootstrapperFeature(loginFlowFeature);
  },
  postBootstrap({ bootstrapperFeatures }) {
    bootstrapperFeatures['account-actions'].onActionRequested(({ actionId }) => {
      if (actionId === ACCOUNT_ACTION_IDS.LOGIN_START) {
        bootstrapperFeatures['login-flow'].start();
      }
    });

    if (window.location.hash === '#login') {
      bootstrapperFeatures['login-flow'].start();
    }
  },
};
